





































































































































































































import Alert from "../../../components/alerts/alert.vue";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
import storeHelper from "../../../store/store-helper";
import { Controllers, Hyperlink } from "@infoland/iprova-api";
import { DocumentCheck } from "@/types/document/checkDocument";
import { Folder, Period } from "@/types/document/folder";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import { DocumentCheckOutcome, DocumentCheckOptions, DocumentVersionState } from "@/enums";
import ZenyaDialog, { IZenyaDialog } from "@/components/dialogs/ZenyaDialog.vue";
import AdvancedUserSelector from "../../../components/generic/UserSelector/AdvancedUserSelector.vue";
import Utils from "@/utils";
import DateSelector from "../../../components/generic/DateSelector.vue";
import UserSelector from "../../../components/generic/UserSelector/UserSelector.vue";
import { UserSelectionItem, UserItem } from "@/components/generic/UserSelector/types";
import moment from "moment";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "CheckDocument",
    components: { UserSelector, AdvancedUserSelector, ZenyaDialog, DateSelector, Alert },
    props: {
        documentId: String,
        version: Number,
        documentVersionInfo: Object as () => DocumentVersionInfo
    },
    data: function () {
        return {
            writersForNewVersion: null as string[],
            inviteNewWritersDialog: false,
            documentCheckOutcomes: { ...DocumentCheckOutcome },
            documentCheckOptions: { ...DocumentCheckOptions },
            documentCheckOption: null as DocumentCheckOptions,
            nextCheckDate: null as string,
            defaultNextCheckDate: null as string,
            defaultPublicationExpirationDate: null as string,
            publicationExpirationDate: null as string,
            defaultWritersHandInDraftDate: null as string,
            writersHandInDraftDate: null as string,
            documentVersion: null as DocumentVersionInfo,
            documentWriters: null as string[],
            invitedWriters: null as UserItem[],
            involvedUsersIDs: null,
            invitedNewWriters: null as UserSelectionItem[],
            instructions: null as string,
            hasNewVersion: false,
            folder: null as Folder,
            nextCheckDateChangeAllowed: false,
            delegatedUser: null as UserItem,
            hasInvolvedUsers: false,
            deleteNewVersion: false,
            newVersionState: null as string,
            isUserDelegate: false,
            hideOkButton: false,
            isLoadingDocumentOption: false,
            loadingComplete: false,
            incomingHyperlinks: [] as Hyperlink[],
            archiveReason: null as string,
            hasNewVersionInDraft: false,
            hasNewVersionInReview: false
        };
    },
    async created() {
        this.registerHandlers({ ok: this.checkDocument });
    },
    computed: {
        isChangesNeeded(): boolean {
            return (
                this.documentCheckOption == this.documentCheckOptions.changes_needed_administrators ||
                this.documentCheckOption == this.documentCheckOptions.changes_needed_writers ||
                this.documentCheckOption == this.documentCheckOptions.changes_needed_me
            );
        },
        formattedDefaultChekcDate(): string {
            return this.defaultNextCheckDate
                ? Utils.formatDate(new Date(this.defaultNextCheckDate), storeHelper.userStore.loggedOnUser?.date_format)
                : null;
        },
        deadlineForWritersIsRequired(): boolean {
            return this.documentCheckOption == this.documentCheckOptions.changes_needed_writers;
        },
        invitedWritersIDs(): any {
            if (this.invitedWriters && this.invitedWriters.length > 0) {
                return this.invitedWriters.map(writer => writer.assigneeId);
            } else {
                return null;
            }
        }
    },
    methods: {
        async init() {
            if (this.documentVersionInfo) {
                if (this.documentVersionInfo.check_task_delegated_to_user) {
                    this.isUserDelegate = this.documentVersionInfo.check_task_delegated_to_user.user_id == this.$user.user_id;
                }
                this.documentVersion = this.documentVersionInfo;
                await this.setDefaultNextCheckDate(this.documentVersion.folder_mini.folder_id);
                this.documentWriters = this.documentVersion.writers_group.map(writer => writer.user_id);

                await this.setInvolvedUsersAsync(this.documentVersionInfo);
                this.hasNewVersion = await this.checkForNewVersion();
                var checkDate = this.documentVersionInfo.check_date.toDate();
                var today = new Date();
                if (checkDate > today) {
                    this.defaultPublicationExpirationDate = Utils.getDatePickerString(checkDate);
                } else {
                    this.defaultPublicationExpirationDate = Utils.getDatePickerString(today);
                }
                var hyperlinks = await Controllers.GenericController.getAsync<Hyperlink[]>(
                    `/hyperlinks?target_document_ids=${this.documentVersion.document_id}&include_source=true&source_available=true`
                );
                if (hyperlinks) {
                    var uniqueExtraItemIds = [];
                    var incomingHyperlinksByExtraId = [];
                    //remove duplicate hyperlinks with the same source extra item id
                    for (var i = 0; i < hyperlinks.length; i++) {
                        if (hyperlinks[i].source_item_extra_id) {
                            if (!(uniqueExtraItemIds.indexOf(hyperlinks[i].source_item_extra_id) > -1)) {
                                uniqueExtraItemIds.push(hyperlinks[i].source_item_extra_id);
                                incomingHyperlinksByExtraId.push(hyperlinks[i]);
                            }
                        } else {
                            incomingHyperlinksByExtraId.push(hyperlinks[i]);
                        }
                    }
                    var uniqueHyperlinksIDs = [];

                    //remove duplicate hyperlinks with the same item id when source extra item id is null
                    for (var i = 0; i < incomingHyperlinksByExtraId.length; i++) {
                        if (!incomingHyperlinksByExtraId[i].source_item_extra_id) {
                            if (!(uniqueHyperlinksIDs.indexOf(incomingHyperlinksByExtraId[i].source_item_id) > -1)) {
                                uniqueHyperlinksIDs.push(incomingHyperlinksByExtraId[i].source_item_id);
                                this.incomingHyperlinks.push(incomingHyperlinksByExtraId[i]);
                            }
                        } else {
                            this.incomingHyperlinks.push(incomingHyperlinksByExtraId[i]);
                        }
                    }
                    // sort hyperlinks alphabetically
                    this.incomingHyperlinks.sort((a, b) => (a.source_full_name || "").localeCompare(b.source_full_name || ""));
                }
            }
            this.documentCheckOption = this.documentCheckOptions.can_remain;
            this.$emit("toggle-ok-button-visibility", false);
        },
        async setDefaultNextCheckDate(folderId: number) {
            var currentDate = new Date();
            this.folder = await Controllers.GenericController.getAsync<Folder>(
                `/documents/folders/${folderId}?include_check_settings=true&is_delegate_user=${this.isUserDelegate}`
            );
            if (this.folder && this.folder.check_settings) {
                this.nextCheckDateChangeAllowed =
                    !this.folder.check_settings.can_change_check_date_on_publication &&
                    this.folder.check_settings.is_check_date_required_on_publication;
                if (this.folder.check_settings.append_to_new_date_value && this.folder.check_settings.append_to_new_date_unit) {
                    switch (this.folder.check_settings.append_to_new_date_unit) {
                        case Period.days:
                            currentDate.setDate(currentDate.getDate() + this.folder.check_settings.append_to_new_date_value);
                            break;
                        case Period.weeks:
                            currentDate.setDate(currentDate.getDate() + this.folder.check_settings.append_to_new_date_value * 7);
                            break;
                        case Period.months:
                            currentDate.setMonth(currentDate.getMonth() + this.folder.check_settings.append_to_new_date_value);
                            break;
                        case Period.years:
                            currentDate.setFullYear(currentDate.getFullYear() + this.folder.check_settings.append_to_new_date_value);
                            break;
                    }
                } else {
                    currentDate.setFullYear(currentDate.getFullYear() + 1);
                }
            }

            currentDate.setMinutes(currentDate.getMinutes() - currentDate.getTimezoneOffset());
            this.defaultNextCheckDate = currentDate.toISOString().slice(0, 10);
            this.nextCheckDate = this.defaultNextCheckDate;
        },
        async checkForNewVersion() {
            const newVersion = await storeHelper.documentStore.loadDocumentVersionIncludingSpecificUsersAsync(
                this.documentId,
                this.version + 1,
                true,
                false,
                false,
                false,
                true,
                false
            );
            if (newVersion) {
                if (newVersion.state === DocumentVersionState.Draft) {
                    this.hasNewVersionInDraft = true;
                    this.newVersionState = this.$t("checkDocument.draft").toString();
                    this.documentWriters = [];

                    let writers = newVersion.writers_group.map(user => user.user_id);
                    this.documentWriters.push(...writers);
                    let invitedWritersToDraft = newVersion.invited_writers.map(user => user.user_id);
                    this.documentWriters.push(...invitedWritersToDraft);
                    if (newVersion.writer_hand_in_deadline_date) {
                        let writersDeadline: Date = new Date(moment(newVersion.writer_hand_in_deadline_date, "YYYYmmdd").toString());
                        writersDeadline.setMinutes(writersDeadline.getMinutes() - writersDeadline.getTimezoneOffset());
                        this.defaultWritersHandInDraftDate = writersDeadline.toISOString().slice(0, 10);
                    }

                    return true;
                } else if (newVersion.state === DocumentVersionState.Review) {
                    this.newVersionState = this.$t("checkDocument.review").toString();
                    this.hasNewVersionInReview = true;
                    return true;
                } else if (newVersion.state === DocumentVersionState.WaitingForPublication) {
                    this.newVersionState = this.$t("checkDocument.waitingForPublication").toString();
                    return true;
                }
            }
            return false;
        },
        async setInvolvedUsersAsync(documentVersionInfo: DocumentVersionInfo) {
            this.involvedUsersIDs = [];
            let tempInvolvedUserIDs = [];

            const administratorUserIDs = documentVersionInfo.document_administrators.map(user => user.user_id);
            const writerUserIDs = documentVersionInfo.writers_group.map(user => user.user_id);
            tempInvolvedUserIDs.push(...writerUserIDs);

            const authorizerUserIDs = documentVersionInfo.authorizers.map(user => user.user_id);
            tempInvolvedUserIDs = tempInvolvedUserIDs.concat(authorizerUserIDs);

            const authorUserIDs = this.documentVersion.authors.map(user => user.user_id);
            tempInvolvedUserIDs = tempInvolvedUserIDs.concat(authorUserIDs);

            const reviewerIDs = (
                await Controllers.GenericController.getAsync<{ user: { user_id: string } }[]>(
                    `documents/${documentVersionInfo.document_id}/reviewers`
                )
            ).map(reviewer => reviewer.user.user_id);
            tempInvolvedUserIDs = tempInvolvedUserIDs.concat(reviewerIDs);

            //remove duplicates
            const tempInvolvedUserIDsNoDuplicates = tempInvolvedUserIDs.filter((item, pos) => tempInvolvedUserIDs.indexOf(item) === pos);

            //remove users that are also document administrator, because they already have task to check document so delegating to them would make no sense
            this.involvedUsersIDs = tempInvolvedUserIDsNoDuplicates.filter(uid => {
                return administratorUserIDs.indexOf(uid) < 0;
            });

            const index = this.involvedUsersIDs.indexOf(storeHelper.userStore.loggedOnUser?.user_id);
            if (index > -1) {
                this.involvedUsersIDs.splice(index, 1);
            }
            if (this.involvedUsersIDs.length > 0) {
                this.hasInvolvedUsers = true;
            }
        },
        validateForm() {
            return (this.$refs.form as Vue & { validate: () => boolean }).validate();
        },
        async inviteNewWriters(): Promise<void> {
            if (!(await (this.$refs.inviteNewWritersDialog as Vue & IZenyaDialog).open())) {
                return;
            } else {
                if (Array.isArray(this.invitedNewWriters)) {
                    this.invitedNewWriters
                        .map(i => ({ assigneeId: i.item_id, name: i.name, type: i.type, data: i.data }))
                        .forEach(selectedItem => {
                            this.documentWriters.push(selectedItem.assigneeId);
                            if (Array.isArray(this.invitedWriters)) {
                                this.invitedWriters.push(selectedItem);
                            } else {
                                this.invitedWriters = [];
                                this.invitedWriters.push(selectedItem);
                            }
                        });
                }
            }
        },
        async checkDocument() {
            if (this.validateForm()) {
                let documentCheck: DocumentCheck = { outcome: null };
                if (this.documentCheckOption == this.documentCheckOptions.can_remain) {
                    documentCheck.next_check_date = Utils.formatDate(new Date(this.nextCheckDate), "yyyyMMdd");
                    documentCheck.outcome = this.documentCheckOutcomes.ok;
                } else if (this.isChangesNeeded) {
                    documentCheck.outcome = this.documentCheckOutcomes.changes_needed;
                    documentCheck.publication_expiration_date = Utils.formatDate(new Date(this.publicationExpirationDate), "yyyyMMdd");
                    if (this.documentCheckOption == this.documentCheckOptions.changes_needed_administrators)
                        this.writersForNewVersion = this.documentVersionInfo.document_administrators?.map(da => da.user_id);
                    if (this.documentCheckOption == this.documentCheckOptions.changes_needed_writers) {
                        this.writersForNewVersion = this.invitedWriters.map(writer => writer.assigneeId);
                    }
                    documentCheck.invite_writer_user_ids = this.writersForNewVersion;
                    documentCheck.instructions = this.instructions;
                    if (this.writersHandInDraftDate) {
                        documentCheck.writer_hand_in_deadline_date = Utils.formatDate(new Date(this.writersHandInDraftDate), "yyyyMMdd");
                    }
                } else if (this.documentCheckOption == this.documentCheckOptions.delegate) {
                    if (!this.hasInvolvedUsers) {
                        return false;
                    }
                    documentCheck.delegated_to_user_id = this.delegatedUser[0]?.assigneeId;
                    documentCheck.outcome = this.documentCheckOutcomes.delegated;
                } else if (this.documentCheckOption == this.documentCheckOptions.archive) {
                    documentCheck.delete_new_version = this.deleteNewVersion;
                    documentCheck.outcome = this.documentCheckOutcomes.archived;
                    documentCheck.instructions = this.instructions;
                    documentCheck.archive_reason = this.archiveReason;
                }

                const postCheckResponse = await storeHelper.documentStore.checkDocument(this.documentId, this.version, documentCheck);
                if (postCheckResponse) {
                    this.$emit("close-check-dialog", documentCheck.outcome);
                }
            }
        },
        selectInviteWriters() {
            if (this.documentCheckOption == this.documentCheckOptions.changes_needed_writers) {
                this.writersForNewVersion = [];
                this.invitedWriters = [];
            } else if (this.documentCheckOption == this.documentCheckOptions.changes_needed_administrators) {
                this.writersForNewVersion = [];
            } else {
                this.writersForNewVersion = [this.$user.user_id.toString()];
            }
        },
        required() {
            return v => !!v || `${this.$t("validation.isRequired")}`;
        },
        requiredDeleteNewVersion() {
            return v => v != null || `${this.$t("validation.isRequired")}`;
        },
        updateWriters(selection: UserItem[]) {
            this.invitedWriters = [...selection];
        }
    },
    watch: {
        writersForNewVersionOption: {
            handler() {
                this.selectInviteWriters();
            },
            immediate: true
        },
        documentVersionInfo: {
            async handler() {
                this.loadingComplete = false;
                await this.init();
                this.loadingComplete = true;
            },
            immediate: true
        },
        documentCheckOption: {
            handler() {
                this.isLoadingDocumentOption = true;
                if (this.documentCheckOption == this.documentCheckOptions.delegate && !this.hasInvolvedUsers) {
                    this.$emit("toggle-ok-button-visibility", true);
                    this.hideOkButton = true;
                } else if (this.hideOkButton == true) {
                    this.$emit("toggle-ok-button-visibility", false);
                }
                this.nextCheckDate = this.defaultNextCheckDate;
                this.writersHandInDraftDate = null;
                this.publicationExpirationDate = this.defaultPublicationExpirationDate;
                if (this.documentCheckOption == this.documentCheckOptions.changes_needed_writers) {
                    this.invitedWriters = null;
                }
                this.instructions = null;
                this.isLoadingDocumentOption = false;
            },
            immediate: true
        }
    }
});
